export default function createInitialValue(formConfigJSON) {
  let initialValues = {};

  // If there are no formFields, return an empty initialValues object
  if (!formConfigJSON?.requestBody?.formFields) {
    return initialValues;
  }

  // Process each field of the formConfigJSON's formFields to generate initial values
  formConfigJSON.requestBody.formFields.fields.forEach((field) => {
    const { name, value } = getInitialValue(field);
    initialValues[name] = value;
  });

  console.log("initialValues: ", initialValues);

  return initialValues;
}

// Function to generate initial values for a field
const getInitialValue = (field) => {
  const dataType = field.dataType.toLowerCase();
  const { name, defaultValue } = field;
  // console.log("name: ", name);

  if (dataType === "object") {
    return { name, value: getInitialValuesFromObj(field.obj) };
  }
  // If dataType is 'array', get the initial values of the array recursively
  else if (dataType === "array") {
    const value =
      defaultValue || field.obj.length === 0
        ? []
        : [getInitialValuesFromObj(field.obj)];
    return { name, value };
  }
  // For these data types, initial value is an empty string
  else if (["string", "number", "date", "file", "boolean"].includes(dataType)) {
    return { name, value: defaultValue?.toString() || "" };
  }
  // Write logic for extra data types
};

/** Function to handle `object` and `array` type fields */
const getInitialValuesFromObj = (obj) => {
  let initialValues = {};
  obj.forEach((item) => {
    // console.log("item: ", item);
    const { name, value } = getInitialValue(item);
    initialValues[name] = value;
  });
  return initialValues;
};
